import React from "react";
import Map from "react-map-gl";
import ConfigurableValues from "../../config/constants";

// mapbox-gl throws if it initialises without an access token, and the token only
// exists once the Configuration query resolves. The app used to hold its ENTIRE
// render behind that query for this one reason, which cost every visitor the
// round trip before anything could start — including the menu query.
//
// Holding back just the map instead lets the rest of the page render straight
// away. A map is never the first thing a customer looks at, and the token lands
// well before checkout or address entry.
//
// Drop-in for <Map> from react-map-gl: same props, same ref, supplies the token
// itself (placed after the spread so a stale undefined from a caller cannot win).
const MapWhenReady = React.forwardRef(({ children, ...props }, ref) => {
  const { MAPBOX_TOKEN } = ConfigurableValues();
  if (!MAPBOX_TOKEN) return null;
  return (
    <Map ref={ref} {...props} mapboxAccessToken={MAPBOX_TOKEN}>
      {children}
    </Map>
  );
});

MapWhenReady.displayName = "MapWhenReady";

export default MapWhenReady;
